import makeTable from "./makeTable";

const clientGroup = makeTable({
	allIds: ["title", "notes", "amount"],
	i18tPath: (id) => `tableColumns.customers.clientGroups.${id}`,
});

export default clientGroup;
